import { axiosInstanceWebsite } from "../instance";

export const getSurveySteps = async (id: string) => {
    const response = await axiosInstanceWebsite.get(`/survey-steps/survey/${id}`);
    return response.data;
};

export const postSurveyFill = async (data: Record<string, any>) => {
    const response = await axiosInstanceWebsite.post('/survey-response/fill', data);
    return response.data;
};

export const getSurveyValidateFormSurvey = async (id: string, entity_type: string, entity_id: string) => {
    const response = await axiosInstanceWebsite.get(`/survey-response/validate/${id}/${entity_type}/${entity_id}`);
    return response.data;
};